/* eslint-disable max-lines */
import { exportUsers } from 'actions';
import { selectUsers } from 'actions/userPermissionsPage';
import Permissions from 'components/Permissions';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getCustomerDomain, getCustomerName } from 'selectors/auth';
import { useSelector } from 'store';
import { useHistory } from 'utils/urls';

const LLUsersHeaderButtons: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const domain = useSelector(getCustomerDomain);
  const customerName = useSelector(getCustomerName);

  const handleExportUsers = (): void => {
    dispatch(exportUsers({ filename: `${customerName}_LLUsers`, export_type: 'll_users' }));
  };

  return (
    <div className="flex flex-row justify-start gap-2">
      <button
        onClick={handleExportUsers}
        type="button"
        className="h-8 button button--secondary focus:outline-none"
        key="export"
      >
        <span className="font-bold whitespace-no-wrap">Download CSV</span>
      </button>

      <Permissions action="customers.list">
        <button
          type="button"
          className="w-36 h-8 flex flex-row justify-center button button--primary focus:outline-none whitespace-no-wrap"
          key="add"
          onClick={(): void => {
            dispatch(selectUsers([]));
            history.pushLookup({ routeName: 'll-users-permissions', customerDomain: domain });
          }}
        >
          Add User
        </button>
      </Permissions>
    </div>
  );
};

export default LLUsersHeaderButtons;
